import { MachineGroup } from './types';

export function normalizeText(s: string): string {
  return s.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

export function filterMachines(groups: MachineGroup[], query: string): MachineGroup[] {
  const q = normalizeText(query.trim());
  if (!q) return groups;
  return groups.filter((g) => normalizeText(g.label).includes(q));
}

export function getTotalPages(count: number, perPage: number): number {
  return Math.max(1, Math.ceil(count / perPage));
}

export function paginate(list: MachineGroup[], page: number, perPage: number): MachineGroup[] {
  const totalPages = getTotalPages(list.length, perPage);
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * perPage;
  return list.slice(start, start + perPage);
}

export function getRange(page: number, perPage: number, total: number): { start: number; end: number } {
  const totalPages = getTotalPages(total, perPage);
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * perPage + 1;
  const end = Math.min(safePage * perPage, total);
  return { start, end };
}

export function countSelected(groups: MachineGroup[]): number {
  return groups.filter((g) => g.checked).length;
}

export function buildPages(page: number, totalPages: number): (number | '…')[] {
  const pages: (number | '…')[] = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) pages.push(i);
    else if (pages[pages.length - 1] !== '…') pages.push('…');
  }
  return pages;
}
